// @flow

import { Colors } from '@zapier/theme';

const FilterGroupsStyles = {
  addFilterButton: {
    margin: '20px 0 0 0',
    [`@media (max-width: 1100px)`]: {
      padding: 0,
    },
  },
  groupDividerLine: {
    margin: '30px 10px',
    background: Colors.adamantium,
    height: '1px',
  },
  wouldRunTag: {
    margin: '0 10px',
    textTransform: 'uppercase',
  },
};

export default FilterGroupsStyles;
